import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-additional-content-update',
  templateUrl: './additional-content-update.component.html',
  styleUrls: ['./additional-content-update.component.scss']
})
export class AdditionalContentUpdateComponent implements OnInit {

  constructor(public modalRef: MDBModalRef) { }

  ngOnInit(): void { window.scroll({top:0,left:0,behavior:"smooth"});
  }

}
